import styled from 'styled-components';
import { media } from '@shared/styles';

export const StyledLoaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;

  ${media.tablet} {
    min-height: 40vh;
  }
`;
